const en = {
  toHome: 'Redirecting to the homepage for you...',
  loginSuccess: 'Login successful',
  loginFailed: 'Login failed',
  acntNotExist: 'Account does not exist, please check',
  acntOrPwdError: 'Account or password is wrong',
  checkFailed: 'Verification failed',
  selOrg: 'Please select the organization you want to enter',
  orgTip1: 'The organization involved in this account does not exist and is not involved in other organizations, please contact the administrator.',
  login: 'Login',
  carousel: 'Carousel',
  acnt: 'Account',
  enterAcnt: 'Please enter',
  pwd: 'Password',
  enterPwd: 'Please enter your password',
  remberPwd: 'Remember password',
  noOrgTip1: 'This account is not involved in the organization, please contact the administrator.',
  pageNotFoundTitle: 'Page Not Found',
  pageNotFoundTip: 'Sorry, the page you visited does not exist.',
  goToBackHome: 'Back Home',
  phoneDisabledTip: 'This phone number has been disabled, please contact the administrator.',
  welcome: 'Welcome to {{ name }}'
};

export default en;